import { StorageService } from 'src/app/providers/storage.service';
import { BuisnessPromotion } from './../../../models/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sm-admin-post-details',
  templateUrl: './admin-post-details.component.html',
  styleUrls: ['./admin-post-details.component.scss'],
})
export class AdminPostDetailsComponent implements OnInit {
  public currentIndex: number = 0;
  public postData: any;
  @Input() slides: any[] = [];
  constructor(private _storageService: StorageService) {}

  next() {
    if (this.currentIndex !== this.slides.length - 1) {
      this.currentIndex++;
    }
  }
  prev() {
    if (this.currentIndex !== 0) {
      this.currentIndex--;
    }
  }

  ngOnInit(): void {
    console.log(history.state);
    this.postData = this._storageService.getValueFromAppStorage(
      'adminPostData'
    );
    let imageArray: any[] = JSON.parse(this.postData.assetInfo);
    // console.log(imageArray);
    imageArray.map((v, i) => {
      let extension = v.imgUrl.substring(v.imgUrl.lastIndexOf('.') + 1);
      console.log(extension);
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        this.slides.push({
          image: v.imgUrl,
          type: 'image',
        });
      }
      if (extension === 'mp4' || extension === 'avi') {
        this.slides.push({
          image: v.imgUrl,
          type: 'video',
        });
      }
    });
  }
}
